export default "__VITE_ASSET__BiG8zPRZ__"